import { Cookies } from 'react-cookie';
import { getFirstPartyVistorId, getPixallId } from '@atc/pixall-fns';
// enable this when deal dashboard sms/text is enabled to consume deal data
// import setTagDealDataMapper from './setTagDealDataMapper';

const sendData = function (data, option) {
  if (data === void 0) {
    data = {};
  }
  if (option === void 0) {
    option = {};
  }
  const {
    birf = {},
    clickType,
    dealXg,
    leadType,
    listing = {},
    // localStorageDeal,
    phoneNumber
  } = data;
  const {
    brand,
    disableTelMetrics,
    telmetricsKey
  } = option;
  if (disableTelMetrics || !telmetricsKey || !phoneNumber) {
    return;
  }
  const pixallFirstPartyId = getFirstPartyVistorId();
  const pixallThirdPartyId = getPixallId() || 'nl';
  const cookies = new Cookies();
  const consumerIP = cookies.get('pxa_ipv4');
  const {
    clickType: inventoryClickType,
    id,
    make,
    model,
    year,
    vin
  } = listing;
  const listingClickType = clickType || inventoryClickType;
  let dealXgId;
  if (leadType === 'phone') {
    dealXgId = dealXg?.id;
  }
  // enable this when deal dashboard sms/text is enabled to consume deal data
  /* let deal;
  if (leadType === 'text') {
      deal = setTagDealDataMapper(dealXg, localStorageDeal);
  } */

  // Sanitize lnx values
  let {
    lnx
  } = birf;
  if (Array.isArray(lnx)) {
    lnx = String(Array.from(new Set(lnx)));
  }

  /* tagData object has to be stringified
     https://v3api.telmetrics.com/reference/post_api-leadtracking-settag
  */
  if (telmetricsKey && phoneNumber) {
    if (typeof window !== 'undefined') {
      const body = {
        key: telmetricsKey,
        tagData: JSON.stringify({
          carid: id,
          cid: birf.cid,
          clickType: listingClickType,
          lnx,
          kenshoo: birf.kenshoo,
          consumerIP,
          pixallFirstPartyId,
          pixallThirdPartyId,
          brandName: brand,
          description: `${year} ${make?.name || make} ${model?.name || model}`,
          url: window.location.href,
          vin,
          dealXgId
          // deal,
        }),
        publishedNumber: phoneNumber
      };
      window.fetch('https://web-2-tel.com/setTag', {
        body: JSON.stringify(body),
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          // Even though `application/json` is being sent,
          // the server doesn't care about this header
          // and using `application/x-www-form-urlencoded` bypasses the preflight request.
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST'
      });
    }
  }
};
export default {
  sendData
};